<template>
  <d-card class="card-small mb-3 h-100">
    <d-card-body>
      <d-form class="chat-box py-2">
        <div class="message-received p-3">Hey, I'm interested in your product</div>
        <div class="message-sent p-3">Great! Here's our site: www.spring.app</div>
        <div class="message-received p-3">Hey, I'm interested in your product</div>
        <div class="message-sent p-3">Great! Here's our site: www.spring.app</div>
      </d-form>
      <div class="send-bar">
        <d-form-textarea size="lg" class="chat-textarea my-2" placeholder="Write message"/>
        <d-button size="sm" class="btn-accent btn-form-end">
          <i class="material-icons">send</i> Send
        </d-button>
      </div>
    </d-card-body>
  </d-card>
</template>

<script>
import Quill from "quill";

export default {
  data() {
    return {
      seconds: "5"
    };
  },
  name: "chatbox",

  mounted() {
    const toolbarOptions = [
      // [{ header: [1, 2, 3, 4, 5, false] }],
      // ["bold", "italic", "underline", "strike"],
      // ["blockquote", "code-block"],
      // [{ header: 1 }, { header: 2 }],
      // [{ list: "ordered" }, { list: "bullet" }],
      // [{ script: "sub" }, { script: "super" }],
      // [{ indent: "-1" }, { indent: "+1" }]
    ];

    // Init the Quill RTE
    new Quill(this.$refs.editor, {
      modules: {
        toolbar: toolbarOptions
      },
      theme: "snow"
    });
  }
};
</script>

